import { TaskBannerSize, TaskSelectBoxSize, TaskType } from '../types';

/**
 * The customer-facing to-do task types — the same set the Collab Hub To-do
 * tab lists (ERM-13220) and the remaining-to-do fetch asks the backend for.
 */
export const EXTERNAL_TODO_TASK_TYPES = new Set<TaskType>([
  'question',
  'section',
  'document',
  'document_conditionally_required',
  'document_type_requested',
]);

export const REQUIRED_DOCUMENT_TASKS = new Set<TaskType>([
  'document_conditionally_required',
  'document_type_required',
]);

export const REQUESTED_DOCUMENT_TASKS = new Set<TaskType>([
  'document_type_requested',
]);

export const REQUESTED_OR_CONDITIONALLY_REQUIRED_DOCUMENT_TASKS =
  new Set<TaskType>([
    ...REQUESTED_DOCUMENT_TASKS,
    'document_conditionally_required',
  ]);

export const THREAD_DOCUMENT_TASKS = new Set<TaskType>(['document']);

export const DOCUMENT_TASKS = new Set<TaskType>([
  ...REQUIRED_DOCUMENT_TASKS,
  ...REQUESTED_DOCUMENT_TASKS,
  ...THREAD_DOCUMENT_TASKS,
]);

export const NON_MESSAGE_TASKS = new Set<TaskType>([
  'qc_mark_required',
  'sme_mark_required',
]);

export const TASK_TYPE_MAPPER_TEXT = new Map<TaskType, string>([
  ['qc_mark_required', 'QC Check Required'],
  ['sme_mark_required', 'SME Check Required'],
  ['document_conditionally_required', 'Conditional Document Required'],
  ['document_type_required', 'Document Required'],
  ['document_type_requested', 'Document Requested'],
  ['document', 'Document'],
  ['question', 'Question'],
  ['section', 'Section'],
]);

export const TASK_BANNER_SIZE_MAP: Record<TaskBannerSize, string> = {
  auto: 'auto',
  full: '100%',
  half: '50%',
};

export const TASK_SELECT_BOX_SIZE_MAP: Record<TaskSelectBoxSize, string> = {
  ...TASK_BANNER_SIZE_MAP,
  compact: '30rem',
  medium: '40rem',
  large: '55rem',
  'x-large': '70rem',
};

export const COLLAB_HUB_MESSAGE_TASKS_ERRORS = {
  AZURE_403_SERVER_ERROR_SPECIAL_CHARS:
    'Message cannot contain invalid special characters',
};
